module.exports = __webpack_public_path__ + "static/img/4.c625d8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/4.png
// module id = ooIJ
// module chunks = 0